var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "payment-create main-content" }, [
    _c(
      "form",
      {
        attrs: { action: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submitPrepaymentRequestData($event)
          },
        },
      },
      [
        _c("div", { staticClass: "page-header" }, [
          _c("h3", { staticClass: "page-title" }, [
            _vm._v(_vm._s(_vm.$t("prepayments.invoice_payment_request"))),
          ]),
          _vm._v(" "),
          _c("ol", { staticClass: "breadcrumb" }, [
            _c(
              "li",
              { staticClass: "breadcrumb-item" },
              [
                _c(
                  "router-link",
                  {
                    attrs: { slot: "item-title", to: "/super-admin/dashboard" },
                    slot: "item-title",
                  },
                  [_vm._v(_vm._s(_vm.$t("general.home")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "breadcrumb-item" },
              [
                _vm.$route.name === "preapproved.invoice.verified"
                  ? _c(
                      "router-link",
                      {
                        attrs: {
                          slot: "item-title",
                          to: "/super-admin/preapproved-invoices",
                        },
                        slot: "item-title",
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$tc("preapproved_invoices.invoice", 2))
                        ),
                      ]
                    )
                  : _c(
                      "router-link",
                      {
                        attrs: {
                          slot: "item-title",
                          to: "/super-admin/invoices",
                        },
                        slot: "item-title",
                      },
                      [_vm._v(_vm._s(_vm.$tc("invoices.invoice", 2)))]
                    ),
              ],
              1
            ),
            _vm._v(" "),
            _c("li", { staticClass: "breadcrumb-item" }, [
              _vm._v(_vm._s(_vm.$t("prepayments.invoice_payment_request"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "page-actions row" }, [
            _c(
              "div",
              { staticClass: "col-xs-2 mr-4" },
              [
                _vm.isRejectedButtonShow
                  ? _c(
                      "base-button",
                      {
                        attrs: {
                          loading: _vm.isLoading,
                          outline: true,
                          size: "large",
                          icon: "times",
                          color: "theme",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.rejectedPrepaymentRequest()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("general.reject")) +
                            "\n          "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-xs-2" },
              [
                _vm.isVerifiedButtonShow
                  ? _c(
                      "base-button",
                      {
                        attrs: {
                          loading: _vm.isLoading,
                          size: "large",
                          icon: "save",
                          color: "theme",
                          type: "submit",
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("general.verify")) +
                            "\n          "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.$route.name === "preapproved.invoice.verified"
          ? _c("SinglePreapprovedInvoiceRow", {
              attrs: { fetchData: _vm.fetchData },
            })
          : _c("SingleInvoiceRow", { attrs: { fetchData: _vm.fetchData } }),
        _vm._v(" "),
        _c("div", { staticClass: "payment-card card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-6" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { staticClass: "form-label" }, [
                      _vm._v(_vm._s(_vm.$t("prepayments.date"))),
                    ]),
                    _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                    _vm._v(" "),
                    _c("base-date-picker", {
                      attrs: {
                        "calendar-button": true,
                        disabled: true,
                        "calendar-button-icon": "calendar",
                      },
                      model: {
                        value: _vm.formData.prepayment_date,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "prepayment_date", $$v)
                        },
                        expression: "formData.prepayment_date",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("prepayments.prepayment_request_number"))
                    ),
                  ]),
                  _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "base-read-box base-read-box-field" },
                    [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.requestNumber) },
                      }),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("prepayments.amount"))),
                  ]),
                  _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "base-read-box base-read-box-field" },
                    [
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$utils.formatMoney(
                              _vm.formData.requested_amount,
                              _vm.customerCurrency
                            )
                          ),
                        },
                      }),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("prepayments.payment_mode"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "base-read-box base-read-box-field" },
                    [
                      _vm.formData.payment_method
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.formData.payment_method.name
                              ),
                            },
                          })
                        : _c("span", {
                            domProps: {
                              innerHTML: _vm._s("No Payment Mode Select"),
                            },
                          }),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("prepayments.offer_requested_on_date"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "base-read-box base-read-box-field" },
                    [
                      _vm.formData.supplier_offer_request &&
                      _vm.formData.supplier_offer_request ==
                        "as_soon_as_possible"
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s("As Soon as Possible"),
                            },
                          })
                        : _vm.formData.supplier_offer_request &&
                          _vm.formData.supplier_offer_request == "select_a_date"
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.formData.formattedSupplierOfferRequestDate
                              ),
                            },
                          })
                        : _vm._e(),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-12" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("prepayments.supplier_comment"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "base-read-box base-read-box-field" },
                    [
                      _vm.formData.supplier_comment
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.formData.supplier_comment),
                            },
                          })
                        : _c("span", {
                            domProps: {
                              innerHTML: _vm._s("No Supplier Comment"),
                            },
                          }),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-12" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { staticClass: "form-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("prepayments.administrator_comment"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("base-text-area", {
                      on: {
                        input: function ($event) {
                          return _vm.$v.formData.superAdmin_comment.$touch()
                        },
                      },
                      model: {
                        value: _vm.formData.superAdmin_comment,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "superAdmin_comment", $$v)
                        },
                        expression: "formData.superAdmin_comment",
                      },
                    }),
                    _vm._v(" "),
                    _vm.$v.formData.superAdmin_comment.$error
                      ? _c("div", [
                          !_vm.$v.formData.superAdmin_comment.maxLength
                            ? _c("span", { staticClass: "text-danger" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("validation.notes_maxlength"))
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-12" }, [
                _c(
                  "div",
                  { staticClass: "form-group collapse-button-container" },
                  [
                    _c(
                      "base-button",
                      {
                        staticClass: "collapse-button",
                        attrs: {
                          loading: _vm.isLoading,
                          icon: "save",
                          color: "theme",
                          type: "submit",
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("prepayments.save_prepayment")) +
                            "\n              "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }